export const getSessionData = async (visitorId) => {
  const ipData = await fetch(
    "https://ipinfo.io/json?token=e336f9005b07b2"
  ).then((response) => response.json());

  const [latitude, longitude] = ipData?.loc?.split(",") || [];

  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const lang = typeof navigator !== "undefined" ? navigator.language : "";
  const width = typeof window !== "undefined" ? window.innerWidth : 1024;

  // ✅ Avoid using `screen` directly
  let screenWidth = null;
  let screenHeight = null;
  let screenColorDepth = null;

  if (typeof window !== "undefined" && window.screen) {
    screenWidth = window.screen.width;
    screenHeight = window.screen.height;
    screenColorDepth = window.screen.colorDepth;
  }

  return {
    browserInfo: {
      userAgent: ua,
      language: lang,
    },
    operatingSystem: (() => {
      if (ua.includes("Win")) return "Windows";
      if (ua.includes("Mac")) return "MacOS";
      if (ua.includes("X11")) return "UNIX";
      if (ua.includes("Linux")) return "Linux";
      return "Unknown";
    })(),
    deviceType: (() => {
      if (width <= 480) return "Mobile";
      if (width <= 768) return "Tablet";
      return "Desktop";
    })(),
    screenResolution: {
      width: screenWidth,
      height: screenHeight,
      colorDepth: screenColorDepth,
    },
    browserLanguage: lang,
    timeZone:
      typeof Intl !== "undefined"
        ? Intl.DateTimeFormat().resolvedOptions()?.timeZone
        : "",
    ipData: {
      ip: ipData?.ip,
    },
    locationData: {
      country: ipData?.country,
      region: ipData?.region,
      city: ipData?.city,
      latitude,
      longitude,
    },
    fromWebsite: typeof window !== "undefined" ? window.location.origin : "",
    currentUrl: typeof window !== "undefined" ? window.location.href : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
    globalVisitorId: visitorId ?? "",
  };
};
